import * as socket from '@/stores/dataManager/socketServices/socketUserService';
import { SocketStatus } from '@/stores/dataStore/memoryStore/const/constIndex';
import { store } from '@/stores/dataStore/reduxStore/store';

export const connectSocketUserAction = () => {
    const { app } = store.getState()
    if (app?.socketStatus !== SocketStatus.CONNECTED) {
        socket.connect()
    }
}

export const closeSocketUserAction = () => {
    socket.disconnect()
}

export const registerAllAccountTopicsAction = (accounts: [], callerId: any) => {
    if (accounts) {
        var accountIds: any[] = [];
        accounts.forEach((account: any) => {
            accountIds.push(account.id)
        });
        socket.registerAllAccountTopics(accountIds, callerId);
    };
};

export const registerCustomerTopicsAction = (custid: string, callerId: any) => {
    if (custid) {
        socket.registerCustomerTopics(custid, callerId);
    };
};